$shm_hitalama_benchmarks_page_metrics $mol_grid
	Col_head* $mol_float
		dom_name \th
		sub <= col_head_content* /$mol_view_content
		attr *
			^
			indexed <= indexed_column* false
	Details* $shm_hitalama_benchmarks_page_metrics_details
		computer <= details_computer* \
		browser <= details_browser* \
	Delete* $shm_hitalama_benchmarks_page_metrics_delete
		remove? <=> row_delete*? null
		enabled <= delete_enabled* true
